import { render, staticRenderFns } from "./InternalFundingLabelRenderer.vue?vue&type=template&id=4c189f5c"
import script from "./InternalFundingLabelRenderer.vue?vue&type=script&lang=ts"
export * from "./InternalFundingLabelRenderer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports